/**
 * Hook to create search icon props
 */
var useSearchIconProps = function useSearchIconProps(isDisabled) {
  return {
    iconId: 'fill.symbol.search',
    staticSize: '20',
    color: isDisabled ? 'state.disabled' : 'base.subtle'
  };
};

export { useSearchIconProps };
//# sourceMappingURL=useSearchIconProps.js.map
